
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'fire-hazmat-graphic',
});
